module.exports = __webpack_public_path__ + "assets/img/TheWayISeeIt_001.a1cf2f2d-ps.jpg";